import React from 'react'
import PropTypes from 'prop-types'

import styles from './ErrorComponent.module.css'

const ErrorComponent = ({ message }) => (
  <div className={styles.container}>
    <div>
      <h1 className={styles.title}>Whooops!</h1>
      <h2 className={styles.subtitle}>Alguma coisa deu errado.</h2>
      <div className={styles.message} dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  </div>
)

ErrorComponent.propTypes = {
  message: PropTypes.string.isRequired,
}

export default ErrorComponent
